import {
  SET_RISKS,
  SELECT_RISK,
  ADD_RISK,
  UPDATE_RISK,
  REMOVE_RISK,
} from "../types/risksTypes";

const initialState = {
  all: [],
  selected: null,
  totalPages: 0,
  sources: [],
};

const risksReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RISKS:
      return {
        ...state,
        all: action.payload.items,
        totalPages: action.payload.totalPages,
        sources: action.payload.sources,
      };
    case SELECT_RISK:
      return { ...state, selected: action.payload };
    case ADD_RISK:
      return { ...state, all: [...state.all, action.payload] };
    case UPDATE_RISK:
      return {
        ...state,
        all: state.all.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.data }
            : item
        ),
      };
    case REMOVE_RISK:
      return {
        ...state,
        all: state.all.filter((item) => item.id !== action.payload),
      };

    default:
      return state;
  }
};

export default risksReducer;
